import Request from 'gd-request';

class ApiStarred {

    constructor() {}

    getStarred() {
        return new Request(this,'GET','starred-items',{});
    }

    addToStarred(taskId, projectId) {
        const postData = {};
        if (taskId) postData.taskId = taskId;
        else if (projectId) postData.projectId = projectId;

        return new Request(this,'POST','starred-items',postData);
    }

    removeFromStarred(taskId, projectId) {
        const postData = {};
        if (taskId) postData.taskId = taskId;
        else if (projectId) postData.projectId = projectId;

        return new Request(this,'POST','starred-items-delete',postData);
    }
}


module.exports = ApiStarred;